/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */
import type { ClinicalOutreachConversation } from "./ClinicalOutreachConversation";
import type { ClinicalVisitConversation } from "./ClinicalVisitConversation";

export interface ClinicalElementsResponse {
  visit_conversations: ClinicalVisitConversation[];
  outreach_conversations: ClinicalOutreachConversation[];
}
